import { useState, useRef, useEffect } from "react";
import ArrowSlider from "~/assets/icons/ArrowSlider";

type Slider = {
    header: JSX.Element | undefined,
    children: React.ReactNode,
    footer: JSX.Element | undefined,
    timeInfinitScroll: number | 0,//seconds
    classMaxWidth: string,
    slow: number | 1
}

export default function Slider({ header, children, footer, timeInfinitScroll, classMaxWidth, slow }: Slider) {

    const [slide, setSlide] = useState<number>(0);
    const ref = useRef<HTMLDivElement>();
    const refC = useRef<HTMLDivElement>();
    const [maxScrollLeft, setmaxScrollLeft] = useState<number>(0);

    useEffect(() => {
        if (timeInfinitScroll != 0) {

            const timer = setTimeout(() => {
                if (ref?.current?.scrollLeft == maxScrollLeft) {
                    scroll(-ref?.current?.scrollLeft)
                } else {
                    scroll(ref?.current?.clientWidth ?? 0 / slow)
                }
            }, timeInfinitScroll);
            return () => clearTimeout(timer);
        }
    });

    useEffect(() => {
        setmaxScrollLeft((ref?.current?.scrollWidth ?? 0) - (ref?.current?.clientWidth ?? 0));
    }, [ref]);

    const scroll = (slider: number) => {
        setmaxScrollLeft((ref?.current?.scrollWidth ?? 15) - (ref?.current?.clientWidth ?? 0));

        let newSlide = ref?.current.scrollLeft + slider;

        if (newSlide <= 0) newSlide = 0;
        if (newSlide >= maxScrollLeft) newSlide = maxScrollLeft;

        ref?.current.scroll({
            top: 0,
            left: newSlide,
            behavior: 'smooth'
        });
        setSlide(newSlide);
    }

    const onScroll = () => {
        setSlide(ref?.current?.scrollLeft ?? 0)
    }
    
    return (
        <section className={`sliderItems`}>
            {header && header}
            <div ref={refC} className={`sliderItems__container relative m-auto p-6 text-center ${classMaxWidth}`}>

                <div className={`sliderItems__arrow left ${slide > 0 && 'show'}`} onClick={() => scroll(ref.current?.clientWidth - ((ref.current?.clientWidth) * 2))}>
                    <ArrowSlider />
                </div>
                <div className={`sliderItems__arrow right ${slide < (maxScrollLeft) && 'show'}`} onClick={() => scroll(ref.current?.clientWidth)}>
                    <ArrowSlider />
                </div>
                <div ref={ref} onScroll={onScroll} className="relative overflow-auto scrollbar-hide flex gap-4">
                    {children}
                </div>
            </div>
            {footer && footer}
        </section >
    )
}

